import { render } from "./productDetails.vue?vue&type=template&id=78c5af4c&scoped=true"
import script from "./productDetails.vue?vue&type=script&lang=js"
export * from "./productDetails.vue?vue&type=script&lang=js"

import "./productDetails.vue?vue&type=style&index=0&id=78c5af4c&scoped=true&lang=css"
/* custom blocks */
import block0 from "./productDetails.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78c5af4c"]])

export default __exports__